var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CardComponent,{attrs:{"text-class":"mx-0"},scopedSlots:_vm._u([{key:"cardTitle",fn:function(){return [_c(_setup.CardTitle,{attrs:{"icon":"mdi-map-marker","title":_vm.spotName}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }